import { render, staticRenderFns } from "./IAgreeCheckbox.vue?vue&type=template&id=0cc37358"
import script from "./IAgreeCheckbox.vue?vue&type=script&lang=js"
export * from "./IAgreeCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports